import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

import { ref, reactive } from 'vue'
  import { layer } from '@layui/layer-vue'
  import { allImgLog,allAgentName} from '../../api'
  
 
   
export default /*#__PURE__*/_defineComponent({
  __name: 'imglog',
  setup(__props) {

  const allAgentNameArr=ref([]);
  const loading = ref(false);
  
  const dataSource = ref([]);
  
  const selectedKeys = ref([]);

  
  const page = reactive({ current: 1, limit: 10, total: 0 });

  const search = reactive({
     key:"", 
    rangeTime:[],
    searchKey:""
  })
  
  const columns = ref([
    { title: "id", key: "id", align: "center" },
     { title: "代理", key: "userId", align: "center"},   
    { title: "访问地址", key: "source", align: "center"},
    { title: "ip", key: "ip", align: "center"},   
    { title: "请求头", key: "userAgent", align: "center"}, 
    { title: "时间", key: "addTime", align: "center" }, 
  ]);
  
  const getAllAdminUser = () => {
    loading.value = true;
 
      var data = { "page": page.current, "limit": page.limit, "key": search.key, "startTime":search.rangeTime[0],"endTime":search.rangeTime[1],"searchKey":search.searchKey};
   
    allImgLog(JSON.stringify(data)).then((res: any) => {
      loading.value = false;
      if (res != "" && res.code == 0) {
        dataSource.value = res.data;
        page.total = res.count;
      } else {
        dataSource.value = [];
        page.total = 0;
      }
    })
  }
  //获取数据
  getAllAdminUser();
  
  const change = (page: any) => {
    getAllAdminUser();
  }
  
  const sortChange = (key: any, sort: any) => {
    layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
  }
   
  //查询接口
  const searchUser = () => {
    page.current=1;
    getAllAdminUser();
  }
 


   const allAgentNameList=()=>{
   
    allAgentName().then((res: any) => {
    
      if (res != "" && res.code == 0) {
        allAgentNameArr.value = res.data;
      
      } else {
        allAgentNameArr.value=[];
      }
    })

  }
  allAgentNameList();

  
return (_ctx: any,_cache: any) => {
  const _component_lay_select_option = _resolveComponent("lay-select-option")!
  const _component_lay_select = _resolveComponent("lay-select")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_input = _resolveComponent("lay-input")!
  const _component_lay_date_picker = _resolveComponent("lay-date-picker")!
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_row = _resolveComponent("lay-row")!

  return (_openBlock(), _createBlock(_component_lay_row, { space: "10" }, {
    default: _withCtx(() => [
      _createVNode(_component_lay_col, { md: "24" }, {
        default: _withCtx(() => [
          _createVNode(_component_lay_panel, null, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form, {
                model: search,
                style: {"text-align":"start"},
                size: "sm"
              }, {
                default: _withCtx(() => [
                  (allAgentNameArr.value.length!=0)
                    ? (_openBlock(), _createBlock(_component_lay_form_item, {
                        key: 0,
                        label: "代理账号",
                        prop: "username",
                        mode: "inline"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_lay_select, {
                            modelValue: search.key,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.key) = $event)),
                            "show-search": true,
                            multiple: false
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allAgentNameArr.value, (agent) => {
                                return (_openBlock(), _createBlock(_component_lay_select_option, {
                                  key: agent.userId,
                                  value: agent.userId,
                                  label: agent.userName
                                }, null, 8, ["value", "label"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_lay_form_item, {
                    label: "搜索",
                    prop: "key",
                    mode: "inline"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_input, {
                        placeholder: "请输入ip/访问",
                        modelValue: search.searchKey,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search.searchKey) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_lay_form_item, {
                    label: "日期范围",
                    mode: "inline"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_date_picker, {
                        modelValue: search.rangeTime,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((search.rangeTime) = $event)),
                        range: "",
                        type: "datetime",
                        placeholder: ['开始日期','结束日期']
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_lay_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_button, {
                        type: "primary",
                        size: "sm",
                        onClick: searchUser
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("查询")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"]),
              _createVNode(_component_lay_table, {
                page: page,
                height: '100%',
                columns: columns.value,
                loading: loading.value,
                "data-source": dataSource.value,
                "selected-keys": selectedKeys.value,
                "onUpdate:selectedKeys": _cache[3] || (_cache[3] = ($event: any) => ((selectedKeys).value = $event)),
                onChange: change,
                onSortChange: sortChange
              }, null, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})